import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';

import styles from './DeviceUpgradeCollection.Styles';

const DeviceUpgradeCollection = ({ collection }) => {
  return (
    <View style={styles.container}>
      {_map(collection, (item, index) => {
        return (
          <View key={`${index}`} style={styles.sectionItem}>
            <Icon name={item.icon} type="image" size={50} />
            <VFText i18nKey={item.name} style={styles.sectionType} />
            <VFText i18nKey={item.days} style={styles.sectionDays} />
            <VFText i18nKey={item.price} type="tertiary" style={styles.sectionPrice} />
          </View>
        );
      })}
    </View>
  );
};
DeviceUpgradeCollection.propTypes = {
  collection: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      days: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      icon: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
    }),
  ),
};
export default DeviceUpgradeCollection;
